var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import History from './History';
import { uuidv4 } from '../../common/utils';
/**
 *
 * @props id: Name to be added to Sidebar
 * @props title: Main title text of Experience Component	(default: Experience)
 * @props textAlign: Experience Text align (default: left)
 * @props theme: You can decorate your experience with a variety of theme such as 'basic', 'box', 'vertical'.	(default: basic)
 * @props headerTitleColor: color of title in Experience component
 * @props historyTitleColor: color of title at historyList
 * @props dateColor: color of date in history List
 * @props descriptionColor: color of description in history List
 * @props shape: shape of card specially used in 'vertical' theme ('square' | 'round-square')
 * @props historyList: You can add your history data such as date, title, description, etc.	({@link https://github.com/modern-agile-team/dev-portfolio/blob/master/app/src/lib/common/types/ComponentTypes/ExperienceType.ts#:~:text=export%20interface-,ExperienceHistoryListType,-%7B "See More about Experience's Props"})
 * @historyList startData: Date when you started that kind experience
 * @historyList endDate: Date when you finished that kind experience
 * @historyList title: Title of experience
 * @historyList description: Describe about your experience
 */
var Experience = function (props) {
    var id = props.id, historyList = props.historyList, title = props.title, textAlign = props.textAlign, theme = props.theme, historyTitleColor = props.historyTitleColor, shape = props.shape, headerTitleColor = props.headerTitleColor, dateColor = props.dateColor, descriptionColor = props.descriptionColor;
    return (_jsxs(Wrap, __assign({ id: id, textAlign: textAlign, headerTitleColor: headerTitleColor }, { children: [_jsx("div", __assign({ className: "title" }, { children: title })), _jsx("hr", {}), _jsx(ChildWrap, __assign({ theme: theme }, { children: historyList === null || historyList === void 0 ? void 0 : historyList.map(function (elements) { return (_jsx(History, __assign({}, elements, { theme: theme, historyTitleColor: historyTitleColor, shape: shape, dateColor: dateColor, descriptionColor: descriptionColor }), uuidv4())); }) }))] })));
};
export default Experience;
Experience.defaultProps = {
    title: 'Experience',
    theme: 'basic',
    historyList: [
        {
            startDate: 'startDate',
            endDate: 'endDate',
            title: 'this is title',
            description: 'This prop name is des.\nWrite down the additional explanation you want here.\nYou can break the line to backslash-n.',
        },
        {
            startDate: 'startDate',
            endDate: 'endDate',
            title: 'this is title',
            description: "If you just want to write the date and time without the text,\ndon't worry !\nYou can write a des props just by emptying it.\nAn example is shown below.",
        },
        {
            startDate: 'startDate',
            endDate: 'endDate',
            title: 'this is title',
        },
    ],
};
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 25px;\n  text-align: ", ";\n  .title {\n    padding: 10px 10px 20px 10px;\n    font-size: 33px;\n    font-weight: 800;\n    color: ", ";\n  }\n  hr {\n    border: 0;\n    height: 1.5px;\n    background: #d6d6d6;\n  }\n"], ["\n  padding: 25px;\n  text-align: ", ";\n  .title {\n    padding: 10px 10px 20px 10px;\n    font-size: 33px;\n    font-weight: 800;\n    color: ", ";\n  }\n  hr {\n    border: 0;\n    height: 1.5px;\n    background: #d6d6d6;\n  }\n"])), function (_a) {
    var textAlign = _a.textAlign;
    return textAlign !== null && textAlign !== void 0 ? textAlign : 'left';
}, function (_a) {
    var headerTitleColor = _a.headerTitleColor;
    return headerTitleColor !== null && headerTitleColor !== void 0 ? headerTitleColor : 'black';
});
var ChildWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  white-space: pre-wrap;\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  white-space: pre-wrap;\n"])), function (_a) {
    var theme = _a.theme;
    return (theme === 'vertical' ? 'row' : 'column');
}, function (_a) {
    var theme = _a.theme;
    return (theme === 'vertical' ? 'wrap' : 'nowrap');
});
var templateObject_1, templateObject_2;
